import React from "react";
import { connect } from "react-redux";
import MaterialTable from "material-table";
import DeleteIcon from "@mui/icons-material/Delete";
import { forwardRef } from 'react';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import Search from '@mui/icons-material/Search';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import { listVenues } from "venues/venueSlice";
import { removeVenue } from "venues/venueSlice";
import { changeName } from "venues/venueSlice";
import { changeZip } from "venues/venueSlice";
import { changeLatitude } from "venues/venueSlice";
import { changeLongitude } from "venues/venueSlice";
import { changeUrl } from "venues/venueSlice";
import { changeAddress } from "venues/venueSlice";
import { changeDescription } from "venues/venueSlice";

const tableIcons = {
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />)
};

class VenueTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      selectedRow: null
    }; 
  }

  componentDidMount() {
    this.props.dispatch(listVenues());
  }

  componentDidUpdate(prevProps) {
    const { currentUser } = this.props;
    if (currentUser !== prevProps.currentUser) {
      this.props.dispatch(listVenues());
    }
  }

  setSelectedRow = row => {
    this.setState({
      selectedRow: row
    });
    const { venueList } = this.props;
    const venue = venueList[row];
    this.props.dispatch(changeName(venue.name));
    this.props.dispatch(changeZip(venue.zip));
    this.props.dispatch(changeLatitude(venue.latitude));
    this.props.dispatch(changeLongitude(venue.longitude));
    this.props.dispatch(changeUrl(venue.url));
    this.props.dispatch(changeAddress(venue.address));
    this.props.dispatch(changeDescription(venue.description));
  }

  clickDelete = venue => {
    this.props.dispatch(removeVenue(venue))
  }

  render() {
    const title = "Venues";
    const columns = [
      { title: 'id', field: 'id', hidden: true },
      { title: 'zip', field: 'zip', hidden: true },
      { title: 'name', field: 'name' },
      { title: 'address', field: 'address' }
    ];
    const { venueList, error } = this.props;
    const data = venueList.map(venue => {
      return {
        id: venue.id,
        zip: venue.zip,
        name: venue.name,
        address: venue.address
      }
    });
    const tableActions = [
      {
        icon: () => <DeleteIcon />,
        tooltip: 'Delete Entry',
        onClick: (event, rowData) => this.clickDelete(rowData)
      }
    ];
    
    const { selectedRow } = this.state;
    return (
      <div style={{ maxWidth: "100%", paddingTop: "12px" }}>
      <MaterialTable
        title={title}
        columns={columns}
        data={data}
        icons={tableIcons}
        actions={tableActions}
        onRowClick={((evt, selectedRow) => this.setSelectedRow(selectedRow.tableData.id))}
        options={{
          headerStyle: {
            backgroundColor: "#01579b",
            color: "#FFF"
          },
          rowStyle: 
            rowData => ({
            backgroundColor: (selectedRow === rowData.tableData.id) ? '#EEE' : '#FFF'
            }),
          padding: 'dense',
          actionsColumnIndex: -1,
          pageSize: 10
        }}
      />
      <div className="text-red-500 text-center">{error}</div>
    </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.users.currentUser,
  venueList: state.venues.venueList,
  error: state.venues.error
});

export default connect(mapStateToProps)(VenueTable);
